import { Routes } from '@angular/router';
// Third party packages
// Custom packages - Misc
import { ArchiveV3RedirectGuard } from 'src/app/shared/guards/archive-v3-redirect.guard';
import { RoleGuard } from 'src/app/shared/guards/role.guard';
import { ARCHIVE_V3_GENERAL_INSERT } from 'src/app/shared/utils/archive-v3-redirect.utils';
// Custom packages - Component
import { AddDocumentsComponent } from 'src/app/modules/add-documents/pages/add-documents/add-documents.page';
var ɵ0 = {
    permissions: ['canReadDocumentsList'],
    archiveV3Redirect: ARCHIVE_V3_GENERAL_INSERT,
};
var routes = [
    {
        // Opens add-documentsV3 instead once the 3.0.0 archive is live (FE-A1, ArchiveV3RedirectGuard)
        path: '',
        component: AddDocumentsComponent,
        canActivate: [ArchiveV3RedirectGuard, RoleGuard],
        data: ɵ0,
    },
    {
        path: '**',
        redirectTo: 'it/errors/404'
    }
];
var AddDocumentsRoutingModule = /** @class */ (function () {
    function AddDocumentsRoutingModule() {
    }
    return AddDocumentsRoutingModule;
}());
export { AddDocumentsRoutingModule };
export { ɵ0 };
